<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                <CCardHeader>
                    <CRow>
                        <!--<CCol md="1">
                            <CDropdown
                                size="sm"
                                v-model="empresaSelected"
                                toggler-text="Empresa1"
                                color="success"
                                class="m-0 d-inline-block"
                                >
                                    <CDropdownItem v-for="empresa in empresas" v-bind:key="empresa.rutEmpresa">
                                        {{empresa.nombreEmpresa}}
                                    </CDropdownItem>
                            </CDropdown>
                        </CCol>
                        <CCol md="1">
                            <CDropdown
                                size="sm"
                                toggler-text="Año1"
                                color="success"
                                class="m-0 d-inline-block ml-2"
                                >
                                    <CDropdownItem v-for="anio in anios" v-bind:key="anio.id">
                                        {{anio.nombre}}
                                    </CDropdownItem>
                            </CDropdown>
                        </CCol>-->
                        <CCol md="4">
                            <multiselect class="m-0 d-inline-block" 
                                v-model="empresaSelected"
                                deselect-label="" 
                                label="nombreEmpresa" 
                                placeholder="Empresas" 
                                select-label=""
                                selectedLabel=""
                                :custom-label="customNameEmpresas"
                                :options="empresas" 
                                :searchable="true"
                                :loading="isLoadingEmpresas"
                                @select="selectEmpresa">
                            </multiselect>
                        </CCol>
                        <CCol md="2">
                            <multiselect class="m-0 d-inline-block" v-model="anioSelected"
                                deselect-label="" 
                                label="anioValor" 
                                placeholder="Años" 
                                select-label=""
                                selectedLabel=""
                                :options="anios" 
                                :searchable="false" 
                                :allow-empty="false"
                                :loading="isLoadingAnios"
                                @select="selectAnio">
                                
                            </multiselect>
                        </CCol>
                        <CCol md="3">
                            <dropdownlist
                                :data-items="anios"
                                :data-item-key="'anioValor'"
                                :text-field="'anioValor'"
                                >
                            </dropdownlist>
                         </CCol>
                    </CRow>
                    <!--<CSwitch
                    class="float-right"
                    size="sm"
                    shape="pill"
                    color="info"
                    data-on="On"
                    data-off="Off"
                    :checked="true"
                    />-->
                </CCardHeader>
                <CCardBody>
                    <CRow>
                        <CCol md="3">
                            <!--<CDropdown
                                size="sm"
                                toggler-text="Mes1"
                                color="success"
                                class="m-0 d-inline-block ml-2 align-middle"
                                >
                                    <CDropdownItem>Mes1</CDropdownItem>
                                    <CDropdownItem>Mes2</CDropdownItem>
                                    <CDropdownItem>Mes3</CDropdownItem>
                            </CDropdown>-->
                            <multiselect class="m-0 d-inline-block" v-model="mesSelected"
                                deselect-label="" 
                                label="mesNombre" 
                                placeholder="Meses" 
                                select-label=""
                                :options="meses" 
                                :searchable="false" 
                                :allow-empty="false"
                                @select="getEmpleados">
                            </multiselect>
                        </CCol>
                        <CCol md="3"></CCol>
                        <CCol md="6">
                            <CRow>
                                <CInput placeholder="Buscar Nombre">
                                    <template #prepend-content><CIcon name="cil-magnifying-glass"/></template>
                                </CInput>
                            </CRow>
                            <CRow>
                                <CInput placeholder="Buscar Rut">
                                    <template #prepend-content><CIcon name="cil-magnifying-glass"/></template>
                                </CInput>
                            </CRow>
                        </CCol>
                    </CRow>
                    <!--<CRow>
                        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                            <CButton color="success" class="ml-2 mt-1" v-on:click="uploadFile()">
                                <CIcon :content="$options.cilArrowThickToBottom"/>
                            </CButton>
                    </CRow>-->
                    <CRow>
                        <CCol md="12">
                            <v-client-table :data="empleadosTable" :columns="columns" :options="options">
                                <template v-slot:contrato="props">
                                    <center>
                                        <CButton color="success" class="ml-2 mt-1">
                                            <CIcon :content="$options.cilArrowThickToBottom"/>
                                        </CButton>
                                        <CButton color="warning" class="ml-2 mt-1">
                                            <CIcon name="cil-pencil"/>
                                        </CButton>
                                    </center>
                                    <!--{{props}}-->
                                    <!--<v-client-table :data="props.row.contrats" :columns="column2" :options="options">
                                    </v-client-table>-->
                                    <!--<div><b>First name:</b> {{props.row.name}}</div>
                                    <div><b>age:</b> {{props.row.age}}</div>-->
                                </template>
                                <template v-slot:finiquito="props" class="text-center">
                                    <center>
                                        <CButton color="success" class="ml-2 mt-1">
                                            <CIcon :content="$options.cilArrowThickToBottom"/>
                                        </CButton>
                                        <CButton color="warning" class="ml-2 mt-1">
                                            <CIcon name="cil-pencil"/>
                                        </CButton>
                                    </center>
                                </template>
                                <template v-slot:anexo="props" class="text-center">
                                    <center>
                                        <CButton color="success" class="ml-2 mt-1">
                                            <CIcon :content="$options.cilArrowThickToBottom"/>
                                        </CButton>
                                        <CButton color="warning" class="ml-2 mt-1">
                                            <CIcon name="cil-pencil"/>
                                        </CButton>
                                    </center>
                                </template>

                            </v-client-table>
                        </CCol>
                    </CRow>
                    <!--<CRow class="mt-2">
                        <CCol md="7">

                            <CDataTable
                                :hover="true"
                                :striped="false"
                                :bordered="true"
                                :small="true"
                                :fixed="true"
                                :items="items"
                                :fields="fields"
                            >-->
                                <!--<template #crud="{item}">
                                    <center>
                                    <CButton color="secondary" class="ml-2 mt-1">
                                        <CIcon name="cil-pencil"/>
                                    </CButton>
                                    <CButton color="secondary" class="ml-2 mt-1">
                                        <CIcon name="cil-pencil"/>
                                    </CButton>
                                    <CButton color="secondary" class="ml-2 mt-1">
                                        <CIcon name="cilXCircle"/>
                                    </CButton>
                                    </center>
                                </template>-->

                                <!--<td
                                    slot="crud"
                                    slot-scope="{item}"
                                    class="text-center textoTabla"
                                    style="padding: 2px;vertical-align:middle;"
                                >
                                    
                                    <CButton color="secondary" class="ml-2 mt-1">
                                        <CIcon name="cil-pencil"/>
                                    </CButton>
                                    <CButton color="secondary" class="ml-2 mt-1">
                                        <CIcon name="cil-pencil"/>
                                    </CButton>
                                    <CButton color="secondary" class="ml-2 mt-1" alt="Eliminar">
                                        <CIcon name="cilXCircle"/>
                                    </CButton> 
                                </td>

                                
                            </CDataTable>
                        </CCol>
                        <CCol md="5"><div>
                            <ckeditor style="width:100%; height: 400px;" :editor="editor" v-model="dataDocumento"></ckeditor>
                            </div>
                        </CCol>
                    </CRow>-->
                </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <!--
        <CRow>
            <CCol md="7">{{editorData}}</CCol>
            <CCol md="5"><div>
                <ckeditor :editor="editor" v-model="editorData"></ckeditor>
                </div></CCol>
        </CRow>
        
        <CRow>
            <CCol md="7">{{content}}</CCol>
            <CCol md="5"><vue-editor v-model="content" :editorToolbar="customToolbar"></vue-editor></CCol>
        </CRow>-->
        
        

        
        <!--<CRow>
        
         :config="editorConfig"
            <CCol md="7">{{content}}</CCol>
            <CCol md="5"><vue-editor v-model="content"></vue-editor></CCol>
        </CRow>
        <CRow>
            <CCol md="7">{{editorData}}</CCol>
            <CCol md="5"><ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor></CCol>
        </CRow>
        <CRow>
            <CCol md="7">{{content2}}</CCol>
            <CCol md="5"><vue-simplemde v-model="content2" ref="markdownEditor" /></CCol>
        </CRow>

        <CRow>
            <CCol md="7">{{content2}}</CCol>
            <CCol md="5"><Vueditor></Vueditor></CCol>
        </CRow>

        <CRow>
            <CCol md="7">{{content2}}</CCol>
            <CCol md="5"><mavon-editor v-model="value"/></CCol>
        </CRow>-->
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import Multiselect from 'vue-multiselect'

    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    //import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

    //import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
    //import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
    /*import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
    import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
    import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';*/

    //import { VueEditor } from "vue2-editor";
    import { freeSet } from '@coreui/icons'
    import cons from '@/const'
    //import { DropDownList } from '@progress/kendo-vue-dropdowns';
    
    //import '@progress/kendo-theme-default/dist/all.css';

    import { cilArrowThickToBottom } from '@coreui/icons'
    
/*
    import { Editor, EditorContent } from 'tiptap'

    import mavonEditor from 'mavon-editor';
    import 'mavon-editor/dist/css/index.css';*/

    import axios from "axios"

    export default {
        name: 'Contratos',
        cilArrowThickToBottom,
        components: {
            //'dropdownlist': DropDownList,
            Multiselect,
            //VueEditor,
            freeSet
        },
        data () {
            return {
                ipServer: "192.168.103.98:8000",
                empresaSelected:null,
                empresas:[],
                anioSelected: null,
                anios:[],
                meses: [],
                mesSelected: null,
                empleados:[],
                empleadoSelected: null,
                isLoadingEmpresas: false,
                isLoadingAnios: false,
                columns: ['rutEmpleado', 'nombreEmpleado', 'anexo', 'contrato', 'finiquito'],
                empleadosTable : [],
                options: {
                    footerHeadings: false,
                    headings: {
                        nombreEmpleado: 'Trabajador',
                        rutEmpleado: 'Rut',
                        anexo: "Anexo",
                        contrato: "Contrato",
                        finiquito: "Finiquito"
                    },
                    // see the options API
                    /*childRow: function(h, row) {
                        return <div>My custom content for row {row.id}</div>
                    }*/
                },
                /*
                columns: ['Empleado', 'Rut', 'opciones', 'N° Contratos'],
                tableData: [
                    { id: 1, name: "John", age: "20", contrats: [{contratDate: "2020-07-01", tipo:"tipo1"}] },
                    { id: 2, name: "Jane", age: "24", contrats: [{contratDate: "2020-08-01", tipo:"tipo1"}] },
                    { id: 3, name: "Susan", age: "16", contrats: [{contratDate: "2020-05-01", tipo:"tipo1"}] },
                    { id: 4, name: "Chris", age: "55", contrats: [{contratDate: "2020-02-01", tipo:"tipo1"}] },
                    { id: 5, name: "Dan", age: "40", contrats: [{contratDate: "2020-04-01", tipo:"tipo1"}] }
                ],*/

                columns2: [
                    {
                        label: 'ID',
                        name: 'id',
                        orderable: true,
                    },
                    {
                        label: 'Name',
                        name: 'name',
                        orderable: true,
                    },
                    {
                        label: 'Email',
                        name: 'email',
                        orderable: true,
                    },
                ],
                asd: [
                    { id: 1, name: "John", age: "20", contrats: [{contratDate: "2020-07-01", tipo:"tipo1"}] },
                    { id: 2, name: "Jane", age: "24", contrats: [{contratDate: "2020-08-01", tipo:"tipo1"}] },
                    { id: 3, name: "Susan", age: "16", contrats: [{contratDate: "2020-05-01", tipo:"tipo1"}] },
                    { id: 4, name: "Chris", age: "55", contrats: [{contratDate: "2020-02-01", tipo:"tipo1"}] },
                    { id: 5, name: "Dan", age: "40", contrats: [{contratDate: "2020-04-01", tipo:"tipo1"}] }
                ],
                
                column2: ['contratDate', 'tipo'],
                
                

                dataDocumento: '<p>&nbsp;</p><p>&nbsp;</p><p class="ql-align-center"><strong>ANEXO AL CONTRATO DE TRABAJO</strong></p><p class="ql-align-center">&nbsp;</p><p class="ql-align-center">&nbsp;</p><p class="ql-align-justify">En Santiago, a Lunes, 24 de Junio de 2013, entre SOFTWAREONE CHILE SPA, R.U.T. 76.089.518-0, representada por don(a) JHONTATAN VIOREL VIOREL, R.U.T. 22.873.104-8, domiciliados ambos en Gertrudis Echeñique Nº 30 Oficina 43, en lo sucesivo el empleador y don(a) NICOLÁS ALFONSO ÁLVAREZ SEPULVEDA, R.U.T. 16.142.268-1, convienen entre las partes la siguiente modificación al Contrato de Trabajo:</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">Para constancia firman las partes el presente Anexo al Contrato de Trabajo en dos ejemplares, quedando uno de ellos en poder de cada parte.</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><figure class="table"><table><tbody><tr><td>asd</td><td>&nbsp;</td></tr></tbody></table></figure><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                fields: [/*'Documento', 'Fecha creación', 'Ver Editar Eliminar'*/
                    {key: 'emp',label: 'Empleado', _classes: 'text-center cabeceraTabla', _style:'width:auto;'},
                    {key: 'fecre',label: 'Fecha creación', _classes: 'text-center cabeceraTabla', _style:'width:auto;'},
                    {key: 'crud',label: 'Opciones', _classes: 'text-center cabeceraTabla', _style:'width:auto;'},
                    {key: 'cantContr',label: 'N° Contratos', _classes: 'text-center cabeceraTabla', _style:'width:auto;'},
                 ],
                 items:[
                    { emp: 'Empleado1', fecre: '01/11/2020', crud: 'Btnes', cantContr: '5'},
                    { emp: 'Empleado2', fecre: '01/11/2020', crud: 'Btnes', cantContr: '5'},
                    { emp: 'Empleado3', fecre: '01/11/2020', crud: 'Btnes', cantContr: '5'},
                ],
                value: "",
                content: '<p>&nbsp;</p><p>&nbsp;</p><p class="ql-align-center"><strong>ANEXO AL CONTRATO DE TRABAJO</strong></p><p class="ql-align-center">&nbsp;</p><p class="ql-align-center">&nbsp;</p><p class="ql-align-justify">En Santiago, a Lunes, 24 de Junio de 2013, entre SOFTWAREONE CHILE SPA, R.U.T. 76.089.518-0, representada por don(a) JHONTATAN VIOREL VIOREL, R.U.T. 22.873.104-8, domiciliados ambos en Gertrudis Echeñique Nº 30 Oficina 43, en lo sucesivo el empleador y don(a) NICOLÁS ALFONSO ÁLVAREZ SEPULVEDA, R.U.T. 16.142.268-1, convienen entre las partes la siguiente modificación al Contrato de Trabajo:</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">Para constancia firman las partes el presente Anexo al Contrato de Trabajo en dos ejemplares, quedando uno de ellos en poder de cada parte.</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><figure class="table"><table><tbody><tr><td>asd</td><td>&nbsp;</td></tr></tbody></table></figure><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                customToolbar: [
                    ["bold", "italic", "underline", "insertTable"], 
                    [{ list: "ordered" }, { list: "bullet" }], ["image", "code-block"], ["table"]],
                content2: "",
                editor: ClassicEditor,
                editorData: '<p>&nbsp;</p><p>&nbsp;</p><p class="ql-align-center"><strong>ANEXO AL CONTRATO DE TRABAJO</strong></p><p class="ql-align-center">&nbsp;</p><p class="ql-align-center">&nbsp;</p><p class="ql-align-justify">En Santiago, a Lunes, 24 de Junio de 2013, entre SOFTWAREONE CHILE SPA, R.U.T. 76.089.518-0, representada por don(a) JHONTATAN VIOREL VIOREL, R.U.T. 22.873.104-8, domiciliados ambos en Gertrudis Echeñique Nº 30 Oficina 43, en lo sucesivo el empleador y don(a) NICOLÁS ALFONSO ÁLVAREZ SEPULVEDA, R.U.T. 16.142.268-1, convienen entre las partes la siguiente modificación al Contrato de Trabajo:</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">Para constancia firman las partes el presente Anexo al Contrato de Trabajo en dos ejemplares, quedando uno de ellos en poder de cada parte.</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><p class="ql-align-justify">&nbsp;</p><figure class="table"><table><tbody><tr><td>&nbsp;</td><td>&nbsp;</td></tr></tbody></table></figure><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                //editorData: '',
                editorConfig: {
                    toolbar:{
                        //items: [ 'bold', 'italic', '|', 'undo', 'redo' ],
                        //viewportTopOffset: 30,

		                //shouldNotGroupWhenFull: true
                    },
                    //toolbar: [ 'bold', 'italic', '|', 'link' ],
                    /*autosave: {
                        save(editor){
                            return this.guardar(editor.getData())
                        }
                    }*/
                    plugins: [
                        //EssentialsPlugin,
                        //BoldPlugin,
                        /*ItalicPlugin,
                        LinkPlugin,
                        ParagraphPlugin*/
                    ],
                },
                file: ''
            }
        },
        created: function(){
            this.getEmpresas();
        },
        beforeMount() {
                

        },
        methods: {
            handleFileUpload(){
                this.file = this.$refs.file.files[0];
            },
            uploadFile(){
                let formData = new FormData();
                formData.append('file', this.file);
                var url = "http://" + cons.ipServer + "/uploadFile/"+this.file.name;
                axios.post(url,
                    formData, 
                    {
                        headers: {
                        'Content-Type': 'multipart/form-data'
                        }
                    }
                    ).then(function () {
                        console.log('SUCCESS!!');
                    }).catch(function () {
                        console.log('FAILURE!!');
                });
                /*axios({
                    method: "POST", 
                    "url": url,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                }).then(result => {
                    //this.empresas = result.data;
                }, error => {
                    let mensaje = `Problema al obtener informacion general, ${error}`
                })
                .finally(() => {
                    this.isLoadingEmpresas = false
                });*/
            },
            customNameEmpresas(empresa){
                return `(${empresa.idEmpresa}) ${empresa.nombreEmpresa}`
            },
            customNameAnios(anio){
                 return `${anio.anioValor}`
            },
            getEmpresas: function(){
                //this.empresas = [{"idEmpresa": "1", "nombreEmpresa": "LUIS CARRASCO TORREALBA", "rutEmpresa": "3682877-3"}, {"idEmpresa": "2", "nombreEmpresa": "ILUMINACION CHILE SPA", "rutEmpresa": "76506868-1"}, {"idEmpresa": "3", "nombreEmpresa": "COMERCIALIZADORA MATI Y MACA SPA", "rutEmpresa": "76572159-8"}, {"idEmpresa": "4", "nombreEmpresa": "SANDOVAL Y COMPA\u00d1IA LIMITADA", "rutEmpresa": "76075860-4"}, {"idEmpresa": "5", "nombreEmpresa": "JOSE SALDIAS MARTINEZ", "rutEmpresa": "4026845-6"}, {"idEmpresa": "6", "nombreEmpresa": "FRANCISCO SILVA CATRILEO", "rutEmpresa": "9262515-K"}, {"idEmpresa": "7", "nombreEmpresa": "ELIANA ALVAREZ BARRERA", "rutEmpresa": "3748995-6"}, {"idEmpresa": "8", "nombreEmpresa": "COMERCIALIZADORA INTERNACIONAL HICA LTDA", "rutEmpresa": "78826590-5"}, {"idEmpresa": "9", "nombreEmpresa": "CORREDORA DE SEGUROS ROSSELOT Y MERINO LTDA", "rutEmpresa": "78194180-8"}, {"idEmpresa": "10", "nombreEmpresa": "DIAZ Y AHUMADA LIMITADA", "rutEmpresa": "76100120-5"}, {"idEmpresa": "11", "nombreEmpresa": "INVERSIONES LEC LTDA", "rutEmpresa": "76457842-2"}, {"idEmpresa": "12", "nombreEmpresa": "VIVIANO CUEVAS VALLEJOS", "rutEmpresa": "5466229-7"}, {"idEmpresa": "13", "nombreEmpresa": "PATRICIA AWAD AHUAD", "rutEmpresa": "6286309-9"}, {"idEmpresa": "14", "nombreEmpresa": "NANCY DEL CARMEN FARIAS SAAVEDRA", "rutEmpresa": "4726959-8"}, {"idEmpresa": "15", "nombreEmpresa": "FERNANDO RODOLFO RICHTER JAQUE", "rutEmpresa": "5128807-6"}, {"idEmpresa": "16", "nombreEmpresa": "COMERC Y DISTRIB DIWHER LTDA", "rutEmpresa": "77099330-K"}, {"idEmpresa": "17", "nombreEmpresa": "MARCELA ALICIA ARRANZ LAGOS", "rutEmpresa": "12150616-5"}, {"idEmpresa": "18", "nombreEmpresa": "JACQUELINE GOMEZ SEGURA", "rutEmpresa": "10237619-6"}, {"idEmpresa": "19", "nombreEmpresa": "SOC DE INVERSIONES Y ESPARCIMIENTO ORIXAS LTDA", "rutEmpresa": "76129167-K"}, {"idEmpresa": "20", "nombreEmpresa": "LOPEZ Y CIA LIMITADA", "rutEmpresa": "79662210-5"}, {"idEmpresa": "21", "nombreEmpresa": "LOPEZ Y COMPA\u00d1IA LIMITADA", "rutEmpresa": "79662210-5"}, {"idEmpresa": "22", "nombreEmpresa": "CARLOS OLAVE HUENCHULLAN", "rutEmpresa": "9407941-1"}, {"idEmpresa": "23", "nombreEmpresa": "SOC DE ESTUDIOS, INVEST Y ASESORIAS JURID E INV", "rutEmpresa": "76131519-6"}, {"idEmpresa": "24", "nombreEmpresa": "FUENZALIDA Y CIA LIMITADA", "rutEmpresa": "85243300-0"}, {"idEmpresa": "25", "nombreEmpresa": "FUENZALIDA Y COMPA\u00d1IA LTDA", "rutEmpresa": "85243300-0"}, {"idEmpresa": "26", "nombreEmpresa": "SANDRO ANTONIO AVILA CONTRERAS", "rutEmpresa": "8000497-4"}, {"idEmpresa": "27", "nombreEmpresa": "PEDRO CLAUDIO HERNANDEZ NARANJO", "rutEmpresa": "6193567-3"}, {"idEmpresa": "28", "nombreEmpresa": "METALURGICA RICHTER Y COMPA\u00d1IA LIMITADA", "rutEmpresa": "79707990-1"}, {"idEmpresa": "29", "nombreEmpresa": "SOLUC. INTEG DE EMBAL MILLAQUEN SPA", "rutEmpresa": "78776800-8"}, {"idEmpresa": "30", "nombreEmpresa": "DOMINGUEZ E HIJO LIMITADA", "rutEmpresa": "77086010-5"}, {"idEmpresa": "31", "nombreEmpresa": "HUGO DOMINGUEZ MELO", "rutEmpresa": "5733111-9"}, {"idEmpresa": "32", "nombreEmpresa": "LABORDA Y BUSTOS LIMITADA", "rutEmpresa": "78639300-0"}, {"idEmpresa": "33", "nombreEmpresa": "DIAZ LETELIER LIMITADA", "rutEmpresa": "77939770-K"}, {"idEmpresa": "34", "nombreEmpresa": "LIBRERIA LA REAL LIMITADA", "rutEmpresa": "76408721-6"}, {"idEmpresa": "35", "nombreEmpresa": "INGENIERIA WLP-CHILE LIMITADA", "rutEmpresa": "76309565-7"}, {"idEmpresa": "36", "nombreEmpresa": "CANALES, CANALES Y CIA SOC. COMERC LTDA", "rutEmpresa": "86749900-8"}, {"idEmpresa": "37", "nombreEmpresa": "INVERSIONES MANGOSTA S.A", "rutEmpresa": "99546670-8"}, {"idEmpresa": "38", "nombreEmpresa": "PERRUQUERIA MONTPARNASSE LIMITADA", "rutEmpresa": "76177762-9"}, {"idEmpresa": "39", "nombreEmpresa": "SOC DE INSTRUMENTOS MUSICALES ALFRA LTDA", "rutEmpresa": "77339630-2"}, {"idEmpresa": "40", "nombreEmpresa": "ONELL Y COMPA\u00d1IA LIMITADA", "rutEmpresa": "50070250-8"}, {"idEmpresa": "41", "nombreEmpresa": "LILLO Y BARRIOS LIMITADA", "rutEmpresa": "76792700-2"}, {"idEmpresa": "42", "nombreEmpresa": "SUR-SERVI LTDA", "rutEmpresa": "76738950-7"}, {"idEmpresa": "43", "nombreEmpresa": "INMOBILIARIA SAPAJ Y COLLAO LIMITADA", "rutEmpresa": "76434620-3"}, {"idEmpresa": "44", "nombreEmpresa": "CALLMARKET LIMITADA", "rutEmpresa": "76327874-3"}, {"idEmpresa": "45", "nombreEmpresa": "PRESTACIONES DE SERVICIOS PORTALPRO SPA", "rutEmpresa": "76383165-5"}, {"idEmpresa": "46", "nombreEmpresa": "SOC GASTRONOMICA AGUILERA Y VENEGAS LIMITADA", "rutEmpresa": "76387226-2"}, {"idEmpresa": "47", "nombreEmpresa": "EDUARDO ANDRES MANGARELLI RODRIGUEZ", "rutEmpresa": "14640687-4"}, {"idEmpresa": "48", "nombreEmpresa": "SANTIAGO PET STORE", "rutEmpresa": "76500894-8"}, {"idEmpresa": "49", "nombreEmpresa": "PONCE Y VARELA LIMITADA B4"}]
                this.isLoadingEmpresas = true
                let cookieUsername = this.$cookie.get('userLoggin')
                var usuLogged = JSON.parse(cookieUsername)

                var userName = usuLogged.userName;
                var cliente = usuLogged.empresa
                var carpeta = usuLogged.carpeta
                var idCliente = usuLogged.idCliente
                //var url = location.protocol + "//" + location.hostname + ":8000/" + "get_empresas/"+userId;
                //'get_empresas/<user_name>/<cliente>/<carpeta>/<id_cliente>'
                var url = "http://" + cons.ipServer + "/get_empresas/"+userName+"/"+cliente+"/"+carpeta+"/"+idCliente;
                
                axios({
                    method: "GET", 
                    "url": url,
                }).then(result => {
                    this.empresas = result.data;
                }, error => {
                    let mensaje = `Problema al obtener informacion general, ${error}`
                })
                .finally(() => {
                    this.isLoadingEmpresas = false
                });
            },
            selectEmpresa: function(empresa){
                
                //this.anios = [{"anioValor": "2016", "meses": [{"mesNombre": "Mayo", "mesValor": "5"}, {"mesNombre": "Abril", "mesValor": "4"}, {"mesNombre": "Marzo", "mesValor": "3"}, {"mesNombre": "Febrero", "mesValor": "2"}, {"mesNombre": "Enero", "mesValor": "1"}]}, {"anioValor": "2015", "meses": [{"mesNombre": "Diciembre", "mesValor": "12"}, {"mesNombre": "Noviembre", "mesValor": "11"}, {"mesNombre": "Octubre", "mesValor": "10"}, {"mesNombre": "Septiembre", "mesValor": "9"}, {"mesNombre": "Agosto", "mesValor": "8"}, {"mesNombre": "Julio", "mesValor": "7"}, {"mesNombre": "Junio", "mesValor": "6"}, {"mesNombre": "Mayo", "mesValor": "5"}, {"mesNombre": "Abril", "mesValor": "4"}]}]

                //this.anios = this.empresaSelected.anios;
                //http://192.168.103.98:8000/get_anios_emp/rvelozo/cliente1/JacquelineCarrasco$/100/6376722
                
                this.isLoadingAnios = true
                let cookieUsername = this.$cookie.get('userLoggin')
                var usuLogged = JSON.parse(cookieUsername)

                var userName = usuLogged.userName;
                var cliente = usuLogged.empresa
                var carpeta = usuLogged.carpeta

                var url = "http://" + cons.ipServer + "/get_anios_emp/"+userName+"/"+cliente+"/"+carpeta+"/"+empresa.idEmpresa+"/"+empresa.rutEmpresa.split("-")[0];
               
                 axios({
                    method: "GET", 
                    "url": url,
                }).then(result => {
                    this.anios = result.data;
                }, error => {
                    let mensaje = `Problema al obtener informacion general, ${error}`
                })
                .finally(() => {
                    this.isLoadingAnios = false
                });
                
            }, 
            selectAnio: function(anio){
                this.meses = anio.meses
                //this.getEmpleados();
                
            },

            getEmpleados: function(mesSeleccionado){
                //this.empleadosTable = [{"rutEmpleado": "7506374-1", "nombreEmpleado": "HENEDINA CRUCES HUEIQUIL"}, {"rutEmpleado": "9969731-8", "nombreEmpleado": "MARIA ISABEL BETANCOURT OLGUIN"}]
                let cookieUsername = this.$cookie.get('userLoggin')
                var usuLogged = JSON.parse(cookieUsername)

                var userName = usuLogged.userName;
                var cliente = usuLogged.empresa
                var carpeta = usuLogged.carpeta

                var url = "http://" + cons.ipServer + "/get_empleados/"+userName+"/"+cliente+"/"+carpeta+"/"+this.empresaSelected.idEmpresa+"/"+this.empresaSelected.rutEmpresa.split("-")[0]+"/"+this.anioSelected.anioValor+"/"+mesSeleccionado.mesValor;
                
                axios({
                    method: "GET", 
                    "url": url,
                }).then(result => {
                    this.empleadosTable = result.data;
                }, error => {
                    let mensaje = `Problema al obtener informacion general, ${error}`
                })
                .finally(() => {
                });
            }
        }
        
    }
</script>

<style>
.multiselect__option{
    padding: 4px 12px 4px 12px;
    min-height: 0;
}
.cabeceraTabla{
  font-size:calc(1em + 0.1vw); 
}

.textoTabla{
  font-size:calc(1em + 0.1vw);
}

.VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
}

.VueTables__child-row-toggler--closed::before {
    content: "+";
}

.VueTables__child-row-toggler--open::before {
    content: "-";
}
</style>